export default __webpack_public_path__ + "phone_mobile.f38285ee.png";